<template>
  <a-button block class="table-cell__actions-btn" type="text" @click="handleShowModal">
    <template #icon>
      <VoicemailIcon />
    </template>

    <a-modal
      v-model:visible="visible"
      v-if="visible"
      centered
      width="680px"
      :mask-closable="false"
      :keyboard="false"
      :body-style="{ padding: '20px 48px' }"
    >
      <template #title> Opciones de IVR - {{ strategy.name }} </template>
      <div class="modal__body">
        <!-- <p>Decide si quieres que sea solo informativo o con retorno hacia tus agentes.</p>

        <a-radio-group v-model:value="typeIvrDerivation">
          <a-radio :value="IvrDerivation.informative" class="radio">
            Informativo
            <a-tooltip>
              <template #title>
                <span>Info</span>
                <InfoCircleOutlined />
              </template>
            </a-tooltip>
          </a-radio>
          <a-radio :value="IvrDerivation.withReturn" class="radio">
            Con retorno
            <a-tooltip>
              <template #title>
                <span>Info</span>
                <InfoCircleOutlined />
              </template>
            </a-tooltip>
          </a-radio>
        </a-radio-group>

        <p class="info">
          <InfoCircleOutlined class="info__icon" />
          <span v-if="isInformative" class="info__text">
            Recuerda que este tipo de estrategia no le permitirá interactuar a tus contactos, solo
            será informativo.
          </span>
          <span v-else class="info__text">
            Recuerda que este tipo de estrategia permitirá interactuar a tus contactos, tu audio
            deberá contar la Opción 1 para conectar con un agente especializado.
          </span>
        </p> -->

        <p>Agrega el audio que reproducirá tu IVR en formato WAV, MP3 o GSM.</p>
        <audio-picker v-model:value="file" :storedFile="this.strategy.file_ivr" />
      </div>

      <template #footer>
        <a-button @click="handleCancel"> Cancelar </a-button>
        <a-button type="primary" :disabled="!file" @click="handleOk" :loading="loading">
          Guardar
        </a-button>
      </template>
    </a-modal>
    <p>Editar audio IVR</p>
  </a-button>
</template>

<script>
import { updateIvrOptions } from "@/app/strategies/services";
import { IvrDerivation } from "@/app/strategies/utils/enums";
import AudioPicker from "@/app/shared/components/molecules/AudioPicker.vue";
import VoicemailIcon from "@/app/shared/components/icons/VoicemailIcon.vue";

export default {
  components: {
    AudioPicker,
    VoicemailIcon,
  },
  props: {
    strategy: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      IvrDerivation,
      visible: false,

      file: null,
      typeIvrDerivation: IvrDerivation.informative,
      loading: false,
    };
  },
  computed: {
    isInformative() {
      return this.typeIvrDerivation === IvrDerivation.informative;
    },
  },
  methods: {
    async handleOk() {
      await this.updateIvrOptions();
      // await this.$store.dispatch("fetchAllStrategies");
      this.visible = false;
      this.$emit("update");
    },
    handleCancel() {
      this.file = null;
      this.visible = false;
    },
    async updateIvrOptions() {
      this.loading = true;

      try {
        const data = new FormData();
        data.append("file_ivr", this.file);
        data.append("type_ivr_derivation", this.typeIvrDerivation);

        await updateIvrOptions(this.strategy.id, data);
        this.$message.success("Se guardaron los cambios");
      } catch (error) {
        this.$message.error("Ha ocurrido un error");
      }

      this.loading = false;
    },
    handleShowModal() {
      this.visible = true;
    },
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    color: $gray-9

.info
  display: flex
  margin: 8px 0 20px 0

  &__icon
    margin: 4px 8px 0 2px

  &__text
    color: $gray-7

.title
  &__icon
    margin-left: 4px

.radio
  display: block
  height: 30px
  line-height: 30px
</style>
